export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";